import { DialogCloseDirective } from './dialog-close.directive';
import { DialogOpenDirective } from './dialog-open.directive';
import { DialogComponent } from './dialog.component';

export { DialogCloseDirective } from './dialog-close.directive';
export { DialogOpenDirective } from './dialog-open.directive';
export { DialogComponent } from './dialog.component';

export const DialogModule = [DialogCloseDirective, DialogOpenDirective, DialogComponent];
